//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { apiRequest } from '../../../Services/Common/ApiRequest';
//#endregion

/**
 * 법규준수평가 (LEG_BASIC) 전용 로직
 * other 케이스에서 사용
 */

// 법규준수평가 인쇄 함수
export const PrintLogic1 = async (
  documentData, // 선택된 항목 데이터
  dispatch,
  setLoading,
  rowData1, // 전체 리스트 (사용하지 않지만 시그니처 통일을 위해 유지)
  modalRowData1, // 모달에서 조회한 상세 데이터
  user,
  searchRef,
  imgRef
) => {
  setLoading(true);

  let headerData = [];
  let tableData = [];

  try {
    // documentData가 배열인 경우 첫 번째 항목 사용
    const selectedItem = Array.isArray(documentData)
      ? documentData[0]
      : documentData;

    if (!selectedItem) {
      dispatch(
        showSnackbar({ message: '항목을 선택하세요.', type: 'warning' })
      );
      return null;
    }

    // 모달이 열리지 않은 상태에서 인쇄 시도한 경우 대비: 데이터 강제 조회
    if (!modalRowData1 || modalRowData1.length === 0) {
      const inputValue = {
        halfYear: selectedItem.lwBranch, // 하반기/상반기 등
      };

      // SearchLogic2 로직을 내부 호출 형태로 직접 재구성
      const result = await apiRequest(
        'post',
        Global.urls.DocsManagement.getLegBasicR2,
        {
          LwYear:
            Commons.EncryptAES(
              searchRef.current.searchDate || searchRef.current.currentYear
            ) || '',
          CustCd: Commons.EncryptAES(searchRef.current.custCd) || '',
          LwBranch: Commons.EncryptAES(inputValue.halfYear) || '',
          UserId: user?.userid || '',
        }
      );

      const data = result.data;
      if (data.length === 0 || data[0]?.type === 'Error') {
        dispatch(
          showSnackbar({
            message: data[0]?.message || '인쇄할 데이터가 없습니다.',
            type: 'error',
          })
        );
        return null;
      } else {
        tableData = Commons.InsertNumber(data);
      }
    } else {
      tableData = modalRowData1;
    }

    const custNm =
      searchRef?.current?.custList?.find(
        (item) => item.value === searchRef?.current?.custCd
      )?.custNm || '';
    const lwEvaDate1 = selectedItem.lwEvaStartDt;
    const lwEvaDate2 = selectedItem.lwEvaEndDt;
    const userSign = !imgRef.current
      ? ''
      : imgRef.current.replace(/^data:image\/[a-z]+;base64,/, '');

    // 레포트 호환: camelCase + 기존 대문자 키를 같이 전달
    headerData.push({
      custNm,
      lwEvaDate1,
      lwEvaDate2,
      userSign,
      CUST_NM: custNm,
      LW_EVA_DATE1: lwEvaDate1,
      LW_EVA_DATE2: lwEvaDate2,
      USER_SIGN: userSign,
    });

    // 레포트 호환: 테이블도 camelCase + 기존 대문자 키를 같이 전달
    tableData = (tableData || []).map((r) => ({
      ...r,
      // camelCase (이미 사용하는 키들)
      lwCd: r.lwCd ?? r.LW_CD ?? '',
      lwNm: r.lwNm ?? r.LW_NM ?? '',
      lwProvisions: r.lwProvisions ?? r.LW_PROVISIONS ?? '',
      lwMain: r.lwMain ?? r.LW_MAIN ?? '',
      lwFine1: r.lwFine1 ?? r.LW_FINE1 ?? 0,
      lwFine2: r.lwFine2 ?? r.LW_FINE2 ?? 0,
      lwFine3: r.lwFine3 ?? r.LW_FINE3 ?? 0,
      lwCompliance: r.lwCompliance ?? r.LW_COMPLIANCE ?? '',
      lwRemark: r.lwRemark ?? r.LW_REMARK ?? '',
      // legacy (기존 레포트 키 유지)
      LW_CD: r.LW_CD ?? r.lwCd ?? '',
      LW_NM: r.LW_NM ?? r.lwNm ?? '',
      LW_PROVISIONS: r.LW_PROVISIONS ?? r.lwProvisions ?? '',
      LW_MAIN: r.LW_MAIN ?? r.lwMain ?? '',
      LW_FINE1: r.LW_FINE1 ?? r.lwFine1 ?? 0,
      LW_FINE2: r.LW_FINE2 ?? r.lwFine2 ?? 0,
      LW_FINE3: r.LW_FINE3 ?? r.lwFine3 ?? 0,
      LW_COMPLIANCE: r.LW_COMPLIANCE ?? r.lwCompliance ?? '',
      LW_REMARK: r.LW_REMARK ?? r.lwRemark ?? '',
    }));

    const printData = {
      FileName: 'LEG_BASIC',
      HeaderData: JSON.stringify(headerData),
      TableData: JSON.stringify(tableData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    // response.data가 blob인 경우 그대로 반환
    if (response.data instanceof Blob) {
      return response.data;
    }
    // response.data가 다른 형태인 경우 blob으로 변환
    else if (response.data) {
      return new Blob([response.data], { type: 'application/pdf' });
    } else {
      console.error('PrintLogic1: 응답 데이터가 없습니다.');
      return null;
    }
  } catch (e) {
    console.error(e);
    dispatch(
      showSnackbar({
        message: e.message || '인쇄 데이터 생성에 실패했습니다.',
        type: 'error',
      })
    );
    return null;
  } finally {
    setLoading(false);
  }
};
